module.exports = __webpack_public_path__ + "images/emoji/kr.8649224daf3347fb5505.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/kr.png
// module id = bxQQ
// module chunks = 24